<template>
  <div class="checkbox-chart">
    <el-row>
      <el-table
        :data="tableData"
        style="width: 100%"
        show-summary
        :summary-method="calcSum">
        <el-table-column
          prop="text"
          label="选项"
          width="600">
        </el-table-column>
        <el-table-column
          prop="count"
          label="小计">
        </el-table-column>
        <el-table-column
          prop="rate"
          label="百分比">
          <template slot-scope='scope'>
            {{ (scope.row.rate * 100).toFixed(1) }}%
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row v-if="showChart">
      <div class="type-selector">
        <el-radio-group v-model="chartType" @change="handleChangeType" size="medium">
          <el-radio-button label="柱状图"></el-radio-button>
          <el-radio-button label="条形图" ></el-radio-button>
          <el-radio-button label="折线图"></el-radio-button>
        </el-radio-group>
      </div>
      <vue-highcharts v-show="chartType == '条形图'" :options="barOptions" ref="barCharts"></vue-highcharts>
      <vue-highcharts v-show="chartType == '柱状图'" :options="columnOptions" ref="columnCharts"></vue-highcharts>
      <vue-highcharts v-show="chartType == '折线图'" :options="lineOptions" ref="lineCharts"></vue-highcharts>
    </el-row>
  </div>
</template>

<script>
import VueHighcharts from 'vue2-highcharts';
export default {
  name: 'checkboxChart',
  props: ['quesInfo', 'showChart'],
  components: {
    VueHighcharts,
  },
  computed: {
    optArr() {
      return this.quesInfo.parseAnswerOptions.map((val) => {
        return this.removeLables(val.text);
      });
    },
    countArr() {
      return this.quesInfo.parseAnswerOptions.map((val) => {
        return val.count;
      });
    },
    barOptions() {
      return {
        chart: {
          type: 'bar',
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: this.optArr,
        },
        yAxis: {
          title: {
            text: ''
          },
        },
        tooltip: {
          crosshairs: true,
          shared: true
        },
        credits: {
          enabled: false
        },
        legend: {
          enabled: false,
        },
        series: [{name: '小计', data: this.countArr}],
      }
    },
    columnOptions() {
      return {
        chart: {
          type: 'column',
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: this.optArr,
        },
        yAxis: {
          title: {
            text: ''
          },
        },
        tooltip: {
          crosshairs: true,
          shared: true
        },
        credits: {
          enabled: false
        },
        legend: {
          enabled: false,
        },
        series: [{name: '小计', data: this.countArr}],
      }
    },
    lineOptions() {
      return {
        chart: {
          type: 'line',
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: this.optArr,
        },
        yAxis: {
          title: {
            text: ''
          },
        },
        tooltip: {
          crosshairs: true,
          shared: true
        },
        credits: {
          enabled: false
        },
        legend: {
          enabled: false,
        },
        series: [{name: '小计', data: this.countArr}],
      }
    },
    tableData() {
      this.quesInfo.parseAnswerOptions.forEach((val) => {
        val.text = this.removeLables(val.text);
      });
      return this.quesInfo.parseAnswerOptions;
    },
  },
  data() {
    return {
      loaded: false,
      chartType: '条形图',
      typeMap: {'柱状图': 'column', '条形图': 'bar', '折线图': 'line'},
    }
  },
  mounted() {
    this.loaded = true;
  },
  methods: {
    handleChangeType(val) {
      let _chart = this.$refs[this.typeMap[val] + 'Charts']
      _chart.removeSeries();
      _chart.addSeries({name: '小计', data: this.countArr});
    },
    calcSum(val) {
      return ['有效填写量', this.quesInfo.answerCount, ''];
    },
    removeLables (html) {
      let text = this.HTMLDecode(html).replace(/<\/?.+?>/g,"");
      return text;
    },
    HTMLDecode(text) {
      let temp = document.createElement("div");
      temp.innerHTML = text;
      let output = temp.innerText || temp.textContent;
      temp = null;
      return output;
    }
  }
}
</script>

<style lang="scss">
  .checkbox-chart {
    .type-selector {
      margin-top: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/singleAnalysis/checkboxChart.vue